import { Component } from '@angular/core';
import { ShowComponent } from '../../common/component/show.component';

@Component({
	selector: 'app-users-group',
	templateUrl: './users-group.component.html',
	styleUrls: ['./users-group.component.css'],
})
export class UsersGroupComponent extends ShowComponent {
	protected itemsBeforeDataLoad = 1;
	protected parentComponent = 'usersGroups';
	rights: Array<any> = [];
	data = {
		id: null,
		name: null,
		rights: [],
		status: 1,
	};

	protected loadBefore() {
		this.api.get('/usersGroupsRights/', (result, error) => {
			this.rights = result.data;
			this.loadData();
		});
	}
}
